import Cookie from 'js-cookie';
import React, { useEffect, useMemo, useState } from 'react';
import { Button, Col, Container, Nav, Row } from 'react-bootstrap';
import { createUseStyles } from 'react-jss';
import { useDispatch, useSelector } from 'react-redux';
import { Link, Route, Switch, useLocation } from 'react-router-dom';
import { checkLoginData, errorSelector, userSelector } from '../appStore/commonSlice';
import { ROLES } from '../const';
import concursarLogo from '../img/logo-concursar.png';
import footerLogo from '../img/logo_argentina-azul.svg';
import Autenticar from './Autenticar';
import ErrorMsg from './CompUtils/ErrorMsg';
// import EvaluacionDocumental from './Concursos/Gestion/TramitarConcursos/CoordinadorConcursal/EtapaEvaluacionDocumental/EvaluacionDocumental';
import DetallePostulacion from './Concursos/Gestion/User/DetallePostulacion';
import CV from './CV';
import ErrorScreen from './ErrorScreen/ErrorScreen';
import GlobalLoading from './GlobalFeedback/Loading';
import GlobalNotification from './GlobalFeedback/Notification';
import Home from './Home';
import Bases from './Home/Bases';
import { DetallePublico } from './Home/DetallePublico';
import { useCheckRoles } from './hooks';
import Login from './Login';
import MainBar from './MainBar';
import PrivateRoute from './PrivateRoute';
import Registro from './Registro';
import UserInfo from './UserInfo';
import Usuario from './Usuario';
import HomeGestion from './Concursos/Gestion/RouteGestionConcursos';
export const BackContext = React.createContext();

const Main = (props) => {
  const isAllowedConcurso = useCheckRoles([
    ROLES.ADMIN,
    ROLES.LEGALES,
    ROLES.COMITE,
    ROLES.DIRECTOR,
  ]);
  const isUser = useCheckRoles([
    ROLES.USER,
    ROLES.ADMIN,
    ROLES.LEGALES,
    ROLES.COMITE,
    ROLES.DIRECTOR,
  ]);
  const esMasQueUser = useCheckRoles([ROLES.LEGALES, ROLES.COMITE, ROLES.DIRECTOR]);

  const isGuest = useCheckRoles(ROLES.GUEST);

  const [checkedCookie, setCheckedCookie] = useState(false);
  const dispatch = useDispatch();

  const [backTo, setBackTo] = useState('/');
  const user = useSelector(userSelector);

  const [autenticado, setAutenticado] = useState(true);

  const { pathname } = useLocation();

  useEffect(() => {
    //Obtengo la authenticación almacenada en cookies
    //Ver tambien persistencia de estado del user en store.js

    const userData = Cookie.get('userConcursar');
    if (userData) {
      dispatch(checkLoginData(JSON.parse(userData)));
    }
    setCheckedCookie(true);
  }, [dispatch]);

  useEffect(() => {
    if (pathname.includes('error-autenticar')) {
      setAutenticado(false);
    }
  }, [pathname]);

  const finalTo = useMemo(() => {
    if (pathname.includes('cargagrilla')) return '/concursos/tramitar';

    return backTo;
  }, [pathname, backTo]);

  if (!checkedCookie) return <div></div>;

  return (
    <>
      <MainBar
        autenticado={autenticado}
        brand={
          <img
            src={concursarLogo}
            alt="Concursar - Oficina Nacional de Empleo Público"
            width="200"
          />
        }
        right={
          <>
            <Nav.Link>
              <Container>
                <Row>
                  {user.token && autenticado && (
                    <Col md={9}>
                      <UserInfo usuario={user}></UserInfo>
                    </Col>
                  )}
                  <Col md={3}>
                    <Login />{' '}
                  </Col>
                </Row>
              </Container>
            </Nav.Link>
            {isGuest && (
              <>
                {/* <Nav.Link as={Link} to="/registrar">
                  <Button variant="link">Registrarse</Button>
                </Nav.Link> */}
              </>
            )}
          </>
        }
        left={
          <>
            {isUser && autenticado && (
              <Nav.Link as={Link} to="/usuario">
                Mi Perfíl
              </Nav.Link>
            )}
            {isUser && autenticado && (
              <Nav.Link as={Link} to="/cv">
                Mi CV
              </Nav.Link>
            )}
            {esMasQueUser && autenticado && (
              <Nav.Link as={Link} to="/concursos">
                Concursos
              </Nav.Link>
            )}
            {/* {isUser && autenticado && (
              <Nav.Link as={Link} to="/postulaciones">
                Mis Postulaciones
              </Nav.Link>
            )} */}
          </>
        }
      />
      <></>

      <>
        <GlobalLoading />
        <GlobalNotification />
        <BackContext.Provider value={{ backTo, setBackTo }}>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/detalle_concurso" component={DetallePublico} />
            <Route
              path="/detalle_concurso/bases"
              component={Bases}
              privateRoute
              isAllowed={isAllowedConcurso}
            />
            <ConcursarRoute
              exact
              path="/usuario"
              contained
              component={Usuario}
              privateRoute
              isAllowed={isUser}
            />
            <ConcursarRoute
              exact
              path="/cv"
              contained
              component={CV}
              privateRoute
              isAllowed={isUser}
            />
            <ConcursarRoute exact path="/registrar" contained component={Registro} />
            <ConcursarRoute exact path="/autenticar" contained component={Autenticar} />
            <ConcursarRoute exact path="/error-autenticar" contained component={ErrorScreen} />
            {/* Aca tengo que hacer que si el ROL es ASPIRANTE me renderice lo de ASPIRANTE y si es ADMIN renderice lo de admin o LEGALES me renderice lo de LEGALES */}
            {isUser ? (
              <>
                <ConcursarRoute
                  path="/concursos"
                  component={HomeGestion}
                  privateRoute
                  isAllowed={isAllowedConcurso}
                />
                {/* <ConcursarRoute
                  exact
                  path="/postulaciones"
                  component={Postulaciones}
                  privateRoute
                  isAllowed={isAllowedConcurso}
                /> */}

                <ConcursarRoute
                  path="/postulaciones/detalle_postulacion/:idPuesto"
                  component={DetallePostulacion}
                  privateRoute
                  isAllowed={isAllowedConcurso}
                />
              </>
            ) : (
              <Route exact path="/" component={Home} />
            )}
            {/* <PrivateRoute exact path="/nuevo" component={AddConcurso} />
            <PrivateRoute exact path="/editar/:id" component={AddConcurso} /> */}
          </Switch>
        </BackContext.Provider>

        {!isGuest && (
          <Container>
            <Row>
              <Col className="text-right">
                {autenticado && (
                  <Link to={finalTo}>
                    <Button variant="secondary">
                      <i className="fa fa-backward"></i>&nbsp; Volver
                    </Button>
                  </Link>
                )}
              </Col>
            </Row>
          </Container>
        )}
        <br />
      </>
      <div style={{ paddingBottom: 100 }}></div>
      <footer className="bg-white py-5">
        <Container>
          <Row>
            <Col sm={6}>
              <a
                href="https://www.argentina.gob.ar/"
                aria-label="Argentina.gob.ar Presidencia de la Nación">
                <img
                  className="image-responsive"
                  alt="Argentina.gob.ar - Presidencia de la Nación"
                  src={footerLogo}
                  height="35"
                />
              </a>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
};

const ConcursarRoute = ({
  component: Component,
  contained = false,
  privateRoute = false,
  isAllowed = null,
  ...rest
}) => {
  const classes = createUseStyles({
    mainContainer: {
      position: 'relative',
      paddingBottom: 50,
    },
  })();
  const RouteComp = privateRoute ? PrivateRoute : Route;
  return (
    <RouteComp
      allowedRoles={privateRoute}
      isAllowed={isAllowed}
      {...rest}
      render={(props) => (
        <Container className={classes.mainContainer} fluid={!contained}>
          <WithError component={Component} compProps={props} />
        </Container>
      )}
    />
  );
};

const WithError = ({ component: Component, compProps }) => {
  const error = useSelector(errorSelector);

  const comp = error.msg ? (
    <div className="text-center">
      <ErrorMsg msg={error.msg} />
    </div>
  ) : (
    <Component props={compProps} />
  );
  return comp;
};
export default Main;
